// MMP1 - FH Salzburg - MultiMediaTechnology
// Tobias Franek <tfranek.mmt-b2018@fh-salzburg.ac.at>

import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import './Container.scss';
import { observable } from 'mobx';
import Request from '../../../api/Request';
import Card from './Card/Card';
import CircleLoader from '../../Util/CircleLoader/CircleLoader';
import Button from '../../Util/Button/Button';
import Subscriber from '../../../api/Subscriber';

@inject('userStore')
@observer class Container extends Component<any, any> {

	@observable matches: any[] = [];

	steps: number = 5;
	currentPosition: number = 0;

	@observable endReached: boolean = false;

	@observable loading: boolean = true;

	@observable empty: boolean = false;

	subscriber = new Subscriber();

	constructor(props: any) {
		super(props);
		
		this.fetch = this.fetch.bind(this);
		this.more = this.more.bind(this);

		this.handleCreateSubscriberMessage = this.handleCreateSubscriberMessage.bind(this);

		this.subscriber.addTopic(
			'/me/matches/' + this.props.userStore.user.id,
			'create_match',
			this.handleCreateSubscriberMessage
		);
	}

	handleCreateSubscriberMessage(response: any) {
		if (response['@match'].participants[0].id === this.props.userStore.user.id || 
			response['@match'].participants[1].id === this.props.userStore.user.id) {
			this.matches = [
				response['@match'],
				...this.matches
			];
		}
	}

	componentDidMount() {
		this.fetch();
		this.subscriber.subscribe();
	}

	componentWillUnmount() {
		this.subscriber.unsubscribe();
	}

	fetch(): void {
		if(!this.endReached) {
			Request.get('/me/matches?offset=' + this.currentPosition + '&limit=' + this.steps, {}).then((response) => {
				if (!response.status) {
					if(response.length === 0 && this.matches.length === 0) {
						this.empty = true;
					}
					if (response.length === this.steps) {
						this.matches = [...this.matches, ...response];
					} else {
						if(response.length < this.steps) {
							this.matches = [...this.matches, ...response];
						}
						this.endReached = true;
					}
					this.loading = false;
				}
			});
		}
	}

	more(): void {
		this.loading = true;
		this.currentPosition += this.steps;
		this.fetch();
	}

	render() {
		return (
			<div className="match-list">
				{this.matches.length > 0 ? 
					this.matches.map((match, index) => (<Card key={index} match={match} />)) 
					: 
					<div>{this.empty ? <p className="no-matches">No Matches yet..</p> : <CircleLoader size={80}/>}</div>
				}
				{!this.endReached && this.matches.length > 0 ? <Button loading={this.loading} text='More' onClick={this.more} /> : null}
			</div>
		)
	}
}

export default Container;

